// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3fVw-","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1tIaA","obliqueLine":"membershipbadge_obliqueLine__2YE3Z"};